// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"325":"d9bbd1d0","511":"c1997039"}[chunkId] + ".chunk.js";
};